import React from 'react';
import { TReferral } from '../../stores';
import { ButtonWithShadow } from '../Buttons/ButtonWithShadow';
import theme, { TMaterialStyles } from '../../theme';
import { Box } from '@mui/material';
import { Icon } from '../Icon';
import TypographyWithShadow from '../Typography/TypographyWithShadow';
import { formatNumberWithCommas } from '../../helpers';
import Image from '../Common/Image';

interface IReferralItem {
  referral: TReferral;
}

export const ReferralItem: React.FC<IReferralItem> = ({ referral }) => {
  return (
    <ButtonWithShadow sx={materialStyles.referralContainer} disabled>
      <Box sx={materialStyles.userIconContainer}>
        <Icon sx={materialStyles.userIcon} iconName="UserIcon" />
        {referral.avatar_url ? (
          <Image
            src={referral.avatar_url}
            alt="avatar"
            sx={materialStyles.userAvatar}
          />
        ) : null}
      </Box>
      <TypographyWithShadow shadowType="DARK" sx={materialStyles.referralName}>
        {referral.name}
      </TypographyWithShadow>
      <Box sx={materialStyles.scoreContainer}>
        <Icon iconName="ScoreIcon" sx={materialStyles.scoreIcon} />
        <TypographyWithShadow
          shadowType="DARK"
          sx={materialStyles.scoreTotalPoints}
        >
          {formatNumberWithCommas(referral.totalPoints)}
        </TypographyWithShadow>
      </Box>
    </ButtonWithShadow>
  );
};

const materialStyles: TMaterialStyles = {
  referralContainer: {
    display: 'flex',
    flexDirection: 'row',
    p: '9px',
    borderRadius: '14px',
    overflow: 'hidden',
  },
  userIconContainer: {
    width: '43px',
    height: '43px',
    borderRadius: '10px',
    backgroundColor: theme.palette.grey[50],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  userAvatar: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  userIcon: {
    width: '25px',
    height: '30px',
  },
  referralName: {
    flex: 1,
    textAlign: 'left',
    marginLeft: '7px',
    fontFamily: 'Rubber Duck !important',
    fontSize: '22px',
    lineHeight: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  scoreIcon: {
    width: '36px',
    height: '36px',
  },
  scoreContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '7px',
    alignItems: 'center',
  },
  scoreTotalPoints: {
    flex: 1,
    fontFamily: 'Rubber Duck !important',
    fontSize: '22px',
    lineHeight: '100%',
  },
};
